import { RouterOutlined } from "@material-ui/icons";
import { GeometrisCommandForm } from "./GeometrisCommandForm";
import { GeometrisCommandsList } from "./GeometrisCommandsList";

export default {
  list: GeometrisCommandsList,
  edit: GeometrisCommandForm,
  icon: RouterOutlined,
};

export type GeometrisCommand =
  | "custom-command"
  | "reset-command"
  | "shipmode-command"
  | "engine-bus-command"
  | "reset-odometer-command"
  | "send-device-configuration";
